import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import DebtiaLoading from '@core/components/debtia-loading/DebtiaLoading.vue'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component(DebtiaLoading.name, DebtiaLoading)
